











































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import PeerCount from '@/components/Validators/PeerCount.vue'
import PeerStake from '@/components/Validators/PeerStake.vue'
import ValidatorStats from '@/components/Validators/ValidatorStats.vue'
import {
    IVersion,
    getPeerInfo,
    getVersionsOnly,
    versionsOnlyMap,
    getVersionsColorMap,
    lower,
    getStakesOnly,
} from '@/services/peerinfo'

@Component({
    components: {
        PeerStake,
        PeerCount,
        ValidatorStats,
    },
})
export default class Metadata extends Vue {
    stakes: null | IVersion[] = null
    stakesColorScale: string[] = []

    versions: null | IVersion[] = null
    versionsColorScale: string[] = []

    loading = false

    created() {
        this.getData()
    }

    async getData() {
        this.loading = true
        const peerInfo = await getPeerInfo()

        // this map is used to create color scales
        const map = versionsOnlyMap(peerInfo)

        // bar chart - only node counts > 0. exclude 'offline'
        this.versions = getVersionsOnly(peerInfo)
        this.versionsColorScale = getVersionsColorMap(map)

        // pie chart - only stakes > 0. include 'offline'
        this.stakes = getStakesOnly(peerInfo)
        this.stakesColorScale = getVersionsColorMap(map) // extend the versions-only color scale
        this.stakesColorScale.push(lower) // by adding extra color for 'offline' stake

        this.loading = false
    }
}
